<div class="h-100 d-flex align-items-center" 
  [ngStyle]="{ 
    'background-color': mergedOptions?.layout.backgroundColor,
    'padding-top': mergedOptions?.layout.padding['top'] + 'px',
    'padding-bottom': mergedOptions?.layout.padding['bottom'] + 'px',
    'padding-left': mergedOptions?.layout.padding['left'] + 'px',
    'padding-right': mergedOptions?.layout.padding['right'] + 'px'
  }">
  <div class="h-100 w-100" [id]="'gauge' + id"></div>
</div>